export default function (svg) {
    // hide from screen readers
    svg.setAttribute('aria-hidden', true);

    // add developer-defined icon classes to the svg
    if (Array.isArray(this.iconClass)) {
        this.iconClass.forEach(cssClass => svg.classList.add(cssClass));
    } else {
        svg.classList.add(this.iconClass);
    }

    // mark all child elements to inherit fill from parent if desired
    if (this.inheritFillFromParent) {
        const recurse = (nodes) => {
            nodes.forEach((child) => {
                if (child.nodeName === 'path' || child.nodeName === 'g') {
                    child.style.fill = 'inherit';
                }

                if (child.childNodes.length) {
                    recurse(child.childNodes);
                }
            });
        };

        recurse(svg.childNodes || []);
    }

    // append svg to root element
    this.$el.appendChild(svg);

    // add assistive text span if needed
    if (this.assistiveText) {
        const span = document.createElement('span');
        span.classList.add('slds-assistive-text');
        span.textContent = this.assistiveText;
        this.$el.appendChild(span);
    }
}
